import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'
import moment from 'moment'

// initial state
const state = () => ({
  all: [],
  options: [],
  columns: [
    {
      label: 'Name', field: 'name'
    },
    {
      label: 'Gender', field: 'gender'
    },
    {
      label: 'Birth Place', field: 'birth_place'
    },
    {
      label: 'Birth Date', field: 'birth_date'
    },
    {
      label: 'Address', field: 'address'
    },
    {
      label: 'Village', field: 'vllg_name'
    },
    {
      label: 'Distric', field: 'rgcy_name'
    },
    {
      label: 'Regency', field: 'dstr_name'
    },
    {
      label: 'Province', field: 'prov_name'
    },
    {
      label: 'Create at', field: 'created_at'
    },
    {
      label: 'Action', field: 'action'
    }
  ],
  pages: [],
  SearchQuery:''
})

// getters
const getters = {
  filtered: state => state.all.filter((all) => {
		return ((all.name.toLowerCase().includes(state.SearchQuery.toLowerCase())))
	}),
}

// actions
const actions = {
  getAll ({ commit }) {
    return new Promise((resolve, reject) => {
      let param = {status: 'master/employees/status/AC'}
      useIPA.get(param).then(response => {
        const employee = {
          rows : response.data.data,
          pages : [10, 25, 50, 150]
        }
        commit('setData', {...employee})
      })
		})
  },
  // fetchUser(ctx, { id }) {
  //   return new Promise((resolve, reject) => {
  //     axios
  //       .get(`/apps/user/users/${id}`)
  //       .then(response => resolve(response))
  //       .catch(error => reject(error))
  //   })
  // },
  getById ({ commit }, id) {
		return new Promise((resolve, reject) => {
      let param = {status: 'master/employee/' + id}
      useIPA.get(param).then(response => {
        resolve(response.data.data)
      })
    })
  },
  formPostPut ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const bodyFormData = new FormData()
			bodyFormData.set('name', formData.text_1)
			bodyFormData.set('gender', formData.radio_2)
			bodyFormData.set('birth_place', formData.text_3)
			bodyFormData.set('birth_date', moment(formData.date_4.split(" "), 'YYYY-MM-DD').format('YYYY-MM-DD'))
			bodyFormData.set('address', formData.text_5)
			// bodyFormData.set('vllg_id', formData.select_9)
      const param = { rawData: bodyFormData, url: 'dashboard/master/employee', id: formData.id }
      useIPA.postput(param)
			.then(response => {
        router.push({ name: 'admin-employee' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  SearchQuery ({ commit }, query) {
		commit('setDataBySearch', query)
	},
  remove ({ commit }, id) {
		return new Promise((resolve, reject) => {
      const param = { url: 'dashboard/master/employee', id: id }
      useIPA.delete(param)
			.then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	}
}

// mutations
const mutations = {
  setData (state, employee) {
    state.all = employee.rows
    state.pages = employee.pages
    state.options = []
    for (let i = 0; i < employee.rows.length; i++) {
      const option = []
      for (const key in employee.rows[i]) {
        if (key === 'id') { 
          option['value'] = employee.rows[i][key] 
        } else if (key === 'name') { 
          option['title'] = employee.rows[i][key] 
        } else if (key === 'id') { 
          option['oid'] = employee.rows[i][key] 
        } 
      }
      state.options.push(Object.assign({}, option))
    }
  },
  setDataBySearch (state, query) {
    state.SearchQuery = query
	},
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
